import { SVGProps } from "react";

export default function UserCircleIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#444D5A", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10.0999 10.6497C10.0416 10.6414 9.9666 10.6414 9.89993 10.6497C8.43327 10.5997 7.2666 9.39974 7.2666 7.92474C7.2666 6.41641 8.48327 5.19141 9.99993 5.19141C11.5083 5.19141 12.7333 6.41641 12.7333 7.92474C12.7249 9.39974 11.5666 10.5997 10.0999 10.6497Z"
        // stroke="#20242A"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6171 16.1498C14.1338 17.5081 12.1671 18.3331 10.0005 18.3331C7.83379 18.3331 5.86712 17.5081 4.38379 16.1498C4.46712 15.3665 4.96712 14.5998 5.85879 13.9998C8.14212 12.4831 11.8755 12.4831 14.1421 13.9998C15.0338 14.5998 15.5338 15.3665 15.6171 16.1498Z"
        // stroke="#20242A"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0003 18.3337C14.6027 18.3337 18.3337 14.6027 18.3337 10.0003C18.3337 5.39795 14.6027 1.66699 10.0003 1.66699C5.39795 1.66699 1.66699 5.39795 1.66699 10.0003C1.66699 14.6027 5.39795 18.3337 10.0003 18.3337Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
